import { useEffect } from 'react';
import { useParams, Link  } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetStoreSaleDetailsQuery } from '../slices/storeSalesApiSlice';

const StoreSaleScreen = () => {
  const { id: storeSaleId } = useParams();

  const { data: storeSale, refetch, isLoading, error } = useGetStoreSaleDetailsQuery(storeSaleId);

  useEffect(() => {
    if (!storeSale) {
      refetch();
    }
  }, [storeSale, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Sale {storeSale?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
                      
              <h2>Customer Details</h2>
              <Message>
              <Link to='/admin/storeSalelist'>Go Back</Link>
              </Message>
              <p>
                <strong>Name: </strong> {storeSale?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {storeSale?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {storeSale?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {storeSale?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {storeSale?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreSale Note</h2>
              <p>{storeSale?.note || 'No additional notes provided'}</p>
              <p>{storeSale?.username || 'No user name provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreSale Items</h2>
              {storeSale?.storeSaleItems?.length === 0 ? (
                <Message>This storeSale has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {storeSale?.storeSaleItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x D{item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                        <Col md={4}>
                          
                          {((item?.qty || 0) * (item?.price || 0) * 1.4).toFixed(0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>StoreSale Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{storeSale?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>TotalRev</Col>
                  <Col>D{storeSale?.totalPrice || 0}</Col>
                </Row>
                <Row>
                  <Col>TotalInsu</Col>
                  <Col>${(storeSale?.totalInsu || 0).toFixed(0)}</Col>
                  
                </Row>

              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{storeSale?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StoreSaleScreen;